"use strict";

import onInitModulesInsScope from "../onInitModulesInScope";

export function init() {
    onInitModulesInsScope(function initInScope($scope) {

        $('.js-switch__input').on('change', function (evt) {
            let parent = $(this).closest('.js-toggle-item');

            if($(this).is(':checked')){
                toggleSwitchItemCheckbox(parent, true);
            }else{
                toggleSwitchItemCheckbox(parent, false);
            }
        });

        $('.js-open-all').on('click', function (evt) {
            evt.preventDefault();
            let parent = $(this).closest('.js-toggle-fieldset');
            toggleSwitchItemCheckbox(parent,true);
        });

        $('.js-close-all').on('click', function (evt) {
            evt.preventDefault();
            let parent = $(this).closest('.js-toggle-fieldset');
            toggleSwitchItemCheckbox(parent,false);
        });

        function toggleSwitchItemCheckbox (parent, isChecked) {
            let icon = parent.find('.js-status');
            let checkbox = parent.find('.js-switch input');

            checkbox.prop('checked', isChecked);

            let status = isChecked ? 'success' : 'danger';
            icon.attr('class', 'status status-' + status + ' js-status');
        }
    })
}